import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';

export const postGenerateReportForClientFromSelectedRecords = async (
  projectId,
  recordIds,
  generationParams,
  projectToUseInReport
) => {
  const apiPath = `report/${projectId}/generate-report-for-client-from-records`;

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: { recordIds, generationParams, projectToUseInReport },
  });

  const response = await axios(signedRequest);

  return response.data;
};
